import React, { Component, useState, useEffect } from "react";
import { withStyles, withTheme } from "@material-ui/core/styles";
import { connect } from "react-redux";
import {
  CardActions,
  CardHeader,
  CardContent,
  Button,
  IconButton,
  TextField,
} from "@material-ui/core";
import { withRouter } from "react-router";
import { useTranslation } from "react-i18next";
import { contentClient } from "../../../AxiosClient";
import EditIcon from "@material-ui/icons/Edit";
import KpsEditor from "../../editor/KpsEditor";
import { makeStyles } from "@material-ui/core/styles";
import DeleteIcon from "@material-ui/icons/Delete";
import AreYouSureDialog from "../../dialog/AreYouSureDialog";
import KpsTextField from "../../KpsTextField";
import { containsScriptOrSVG, containsBadCharacter } from "../../../utils/ContentChecker";
import {
  setGlobalAlert
} from "../../../redux/actions/universalActions";
import {
  setCustomFields,
} from "../../../redux/actions/customFieldsActions";
const useStyles = makeStyles((theme) => ({
  icons: {
    color: theme.palette.text.secondary,
  },
}));
function ReusableSection(props) {
  const [reusableSection, setReusableSection] = useState({});
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [attachmentIds, setAttachmentIds] = useState([]);
  const [edit, setEdit] = useState(false);
  const [areyouSure, setAreyouSure] = useState(false);
  const classes = useStyles();
  const { t } = useTranslation();
  useEffect(() => {
    setTitle(props.section.title);
  }, []);
  const saveSection = () => {
    if (containsScriptOrSVG([content])) {
      props.setGlobalAlert({type:"error", message:"harmful_content", open:true})
      return;
    } else if (containsBadCharacter([content])){
      props.setGlobalAlert({type:"error", message:"unusable_character", open:true})
      return;
    }
    if (props.section.new) {
      contentClient
        .post(`/reusablesection/`, {
          ...props.section,
          title,
          content,
          attachmentIds,
          customFieldsRVOs:props.currentCustomFields
        })
        .then((res) => {
          props.addSectionToList(res.data);
        });
    } else {
      contentClient
        .patch(`/reusablesection/${props.section.reusableSectionId}`, {
          ...props.section,
          title,
          content,
          attachmentIds,
        })
        .then((res) => {
          props.replaceSection(res.data);
          setEdit(false);
          setAreyouSure(false);
        });
    }
  };
  const deleteSection = () => {
    contentClient
      .delete(`/reusablesection/${props.section.reusableSectionId}`)
      .then((res) => {
        props.removeSection(props.section);
      });
  };
  const change = (content) => {
    setContent(content);
  };
  const updateUploadArray = (array) => {
    setAttachmentIds(array);
  };
  return (
    <>
      <CardHeader
        title={
          edit || props.section.new ? (
            <KpsTextField
              aria-label="Reusable section title input"
              fullWidth
              required
              label="Title"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              margin="normal"
            />
          ) : (
            props.section.title
          )
        }
        action={
          !props.addSection &&
          !edit &&
          !props.section.new &&
          props.user.userPermits.roles.contentAdmin && (
            <>
              <IconButton
                color="default"
                aria-label="Delete reusable section"
                onClick={() => setAreyouSure(true)}
              >
                <DeleteIcon />
              </IconButton>
              <IconButton
                color="default"
                aria-label="Edit section"
                onClick={() => {setEdit(true); 
                  if(props.section.customFieldsRVOs!=null){
                    props.setCustomFields(props.section.customFieldsRVOs);
                  }}}
              >
                <EditIcon />
              </IconButton>
            </>
          )
        }
      />
      <CardContent>
        <KpsEditor
          readOnly={!(edit || props.section.new)}
          updateUploadArray={updateUploadArray}
          onChange={change}
          initialContent={props.section.content}
          resize
        />
      </CardContent>
      <CardActions>
        {(edit || props.section.new) && (
          <>
          <div></div>
            <Button
              size="small"
              color="primary"
              onClick={() => {
                setEdit(false);
                if (props.section.new) {
                  props.removeSection(props.section);
                }
              }}
            >
              Cancel
            </Button>
            <Button
              size="small"
              color="primary"
              onClick={() => (edit ? setAreyouSure(true) : saveSection())}
            >
              Save
            </Button>
          </>
        )}
        {props.addSection &&
          (!props.selected ? (
            <Button
              size="small"
              color="primary"
              onClick={() => props.onSelected(props.section)}
            >
              Select
            </Button>
          ) : (
            <Button size="small" color="primary" onClick={props.onBack}>
              Back
            </Button>
          ))}
      </CardActions>
      <AreYouSureDialog
        open={areyouSure}
        onClose={() => setAreyouSure(false)}
        onSubmit={!edit ? deleteSection : saveSection}
      >
        {!edit ? (
          <div>{t("are_you_sure_reusable_section")}</div>
        ) : (
          <div>
            This will cause {props.section.templateSections} template sections,
            and {props.section.contentSections} revision sections to be changed
            and reindexed.
          </div>
        )}
      </AreYouSureDialog>
    </>
  );
}
const mapStateToProps = (state) => ({
  user: state.user.currentUser,
  currentCustomFields: state.customFields.currentCustomFields,
});
const mapDispatchToProps = {
  setGlobalAlert,
  setCustomFields,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withTheme(ReusableSection)));
